export enum TOOL_HISTORY_ITEM_TYPE {
  GROUP = 'group',
  EVENT = 'event'
}

export interface IToolHistoryLocation {
  id: number;
  locationName: string;
  place: string;
  flag?: string;
  country?: string;
}

export interface IToolHistoryGroupLocation {
  origin?: IToolHistoryLocation;
  destination?: IToolHistoryLocation;
}

export interface IToolHistoryGroupReference {
  id: number;
  referenceType: string;
  referenceId: number | null;
  isCancelled?: boolean;
}

export interface IToolHistoryRelevantInfo {
  conditionId?: number;
  statusId?: number;
  condition?: string;
  status?: string;
  configurationName?: string;
  locationOriginName?: string;
  locationDestinationName?: string;
  departureDate?: Date;
  arrivalDate?: Date;
  previousValue?: string;
  newValue?: string;
  responsibleUserName?: string;
  createdAt?: Date;
}

export interface IToolHistoryEntry {
  id: number | null;
  uuid: string | null;
  name: string | null;
  relevantInfo?: IToolHistoryRelevantInfo;
}

export interface IToolHistoryGrouped {
  id: number;
  type: TOOL_HISTORY_ITEM_TYPE.GROUP;
  location: IToolHistoryGroupLocation;
  reference?: IToolHistoryGroupReference;
  closedAt?: Date;
  createdAt: Date;
  events: IToolHistoryEntry[];
}

export interface IToolHistoryUngrouped extends IToolHistoryEntry {
  type: TOOL_HISTORY_ITEM_TYPE.EVENT;
}

export type TToolHistoryItem = IToolHistoryGrouped | IToolHistoryUngrouped;

export type TToolHistoryResponse = TToolHistoryItem[];
